import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  fiat: {
    id: 'Settings.receivedPaymentCurrencies.fiat',
    defaultMessage: 'Cash only',
  },
  cashAndEth: {
    id: 'Settings.receivedPaymentCurrencies.cashAndEth',
    defaultMessage: 'Cash and ETH',
  },
  eth: {
    id: 'Settings.receivedPaymentCurrencies.eth',
    defaultMessage: 'ETH only',
  },
});
